import _ from 'lodash'

import { ApiPortfolioInvestment } from '@/api'

import { LinkButton } from '../../atoms'
import { Percent } from '../../atoms/percent'
import { StyledAssetTable } from './primitives'

type Asset = {
  id: string
  investment?: number
  name: string
  return: number
  volatility: number
  weight?: number
}

export type AssetTableProps = {
  assets?: Asset[]
  investmentWeights?: ApiPortfolioInvestment[]
  isFundOfFunds: boolean
  onClickAsset?: (id: string) => void
}

export function AssetTable({
  assets,
  investmentWeights,
  isFundOfFunds,
  onClickAsset
}: AssetTableProps) {
  const assetsClone = _.cloneDeep(assets)
  const newAssets = assetsClone?.map(asset => {
    const investmentWeight = investmentWeights?.find(x => x.assetId === asset.id)
    if (isFundOfFunds && asset.investment === undefined && investmentWeight !== undefined) {
      return {
        ...asset,
        investment: investmentWeight.weight
      }
    }
    return asset
  })

  return (
    <StyledAssetTable>
      <thead>
        <tr>
          <th className="asset">Asset</th>
          <th className="return">Return</th>
          <th className="volatility">Volatility</th>
          <th className="weight">{isFundOfFunds ? 'Target (%)' : 'Weight (%)'}</th>
          {isFundOfFunds && <th className="investment">Investment (%)</th>}
        </tr>
      </thead>
      <tbody>
        {Array.isArray(newAssets) &&
          newAssets.map(asset => (
            <tr key={asset.name}>
              <td className="asset">
                {onClickAsset !== undefined ? (
                  <LinkButton underline onClick={() => onClickAsset(asset.id)}>
                    {asset.name}
                  </LinkButton>
                ) : (
                  asset.name
                )}
              </td>
              <td className="return">
                <Percent
                  fixed
                  highlightPnl
                  numDecimalPlaces={2}
                  value={asset.return === null ? null : asset.return * 100}
                />
              </td>
              <td className="volatility">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.volatility === null ? null : asset.volatility * 100}
                />
              </td>
              <td className="weight">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.weight * 100}
                />
              </td>
              {asset.investment && (
                <td className="investment">
                  <Percent
                    fixed
                    highlightPnl={false}
                    numDecimalPlaces={2}
                    value={asset.investment * 100}
                  />
                </td>
              )}
            </tr>
          ))}
      </tbody>
    </StyledAssetTable>
  )
}
